/**
 * Central auth provider configuration.
 * Set REACT_APP_AUTH_PROVIDER to 'keycloak' to use Keycloak; defaults to MSAL.
 *
 * In test mode (REACT_APP_TEST_MODE=true) the provider can be overridden at runtime
 * via window.__authProvider__ before the app loads (e.g. via Playwright's addInitScript).
 */

export type AuthProvider = 'msal' | 'keycloak';

declare global {
  interface Window {
    __authProvider__?: AuthProvider;
  }
}

function resolveAuthProvider(): AuthProvider {
  if (process.env.REACT_APP_TEST_MODE === 'true' && window.__authProvider__) {
    return window.__authProvider__;
  }
  return process.env.REACT_APP_AUTH_PROVIDER === 'keycloak' ? 'keycloak' : 'msal';
}

export const authProvider: AuthProvider = resolveAuthProvider();
export const isMsalProvider = authProvider === 'msal';
